import React from 'react';
import './App.css';
import { appConfig } from './config/sections.config';
import Header from './sections/Header';
import Hero from './sections/Hero';
import Services from './sections/Services';
import Vision from './sections/Vision';
import About from './sections/About';
import Team from './sections/Team';
import Experts from './sections/Experts';
import Timeline from './sections/Timeline';
import Testimonials from './sections/Testimonials';
import FAQ from './sections/FAQ';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const App: React.FC = () => {
  const componentMap: { [key: string]: React.FC } = {
    Header,
    Hero,
    Services,
    Vision,
    About,
    Team,
    Experts,
    Timeline,
    Testimonials,
    FAQ,
    Contact,
    Footer,
  };

  return (
    <div className="App">
      {appConfig.sections
        .filter((section) => section.enabled)
        .map((section) => {
          const Component = componentMap[section.component];
          return Component ? <Component key={section.id} /> : null;
        })}
    </div>
  );
};

export default App;
